<template>
  <v-container v-resize="getWindowWidth">
    <v-row justify="end">
      <v-col cols="12" sm="6" md="4" lg="3" xl="2">
        <v-card>
          <v-card-text>
            <div
              class="subtitle-2 grey--text text--darken-1 font-weight-medium"
            >
              {{ $t("domains.title") }}
            </div>
            <div
              class="display-1 text-right yellow--text text--darken-4 font-weight-black"
            >
              {{ this.domainsTable.total }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-layout wrap>
      <v-flex xs12 pt-4>
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="10">
                {{ $t("domains.title") }}
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row justify="end">
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="domainsTable.search"
                  append-icon="search"
                  :label="$t('general.search')"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-data-table
            :loading="isLoading"
            :headers="headers"
            :items="domainsTable.items"
            :search="domainsTable.search"
            class="elevation-1"
            :page.sync="domainsTable.pagination.page"
            :items-per-page.sync="domainsTable.pagination.itemsPerPage"
            :server-items-length="domainsTable.total"
            :footer-props="{ 'items-per-page-options': [5, 20, 50, 100] }"
            @update:page="page => getAllDomains()"
            @update:items-per-page="getAllDomains"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>
                  <span class="font-weight-medium">
                    {{ item.name }}
                  </span>
                </td>
                <td>
                  {{ item.created_at || moment("lll") }}
                </td>
                <td>
                  {{ item.status }}
                </td>
                <td>
                  <v-menu>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon>
                        <v-icon>more_vert</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        @click="openStatusDialog(item.id, item.organization_id)"
                      >
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ $t("domains.change_status") }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <StatusDialog
      v-if="dialogStatus"
      :dialog="dialogStatus"
      @close="closeStatusDialog"
      @confirm="updateStatus"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";

import StatusDialog from "@/components/Domains/StatusDialog";

export default {
  name: "Domains",
  components: { StatusDialog },

  data() {
    return {
      dialogStatus: false,
      selectedDomain: null,
      isLoading: false,
      domainsTable: {
        items: [],
        total: 0,
        search: null,
        pagination: {
          page: 1,
          itemsPerPage: 20,
          sortBy: ["created_at"],
          sortDesc: [false]
        }
      },

      width: "95%",
      width2: "40%",
      headers: [
        {
          text: this.$t("domains.table.domain"),
          value: "name",
          class: "text-no-wrap blue--text text--darken-4",
          width: ""
        },
        {
          text: this.$t("domains.table.date"),
          value: "created_at",
          class: "text-no-wrap blue--text text--darken-4",
          width: ""
        },
        {
          text: this.$t("domains.table.status"),
          value: "status",
          class: "text-no-wrap blue--text text--darken-4",
          width: ""
        },
        {
          text: "",
          value: "",
          class: "text-no-wrap blue--text text--darken-4",
          width: "",
          sortable: false
        }
      ]
    };
  },
  async created() {
    this.isLoading = true;
    await this.getAllDomains();
    this.isLoading = false;
  },
  computed: {
    ...mapState({
      domains: ({ domains: { domains } }) => domains,
      domainsTotal: ({ domains: { domainsTotal } }) => domainsTotal
    })
  },
  watch: {
    "domainsTable.search": {
      handler() {
        this.getAllDomains();
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      getAll: "domains/getAll",
      updateDomain: "domains/updateDomain"
    }),

    async getAllDomains() {
      let { sortBy, sortDesc = false } = this.domainsTable.pagination;
      const { page, itemsPerPage } = this.domainsTable.pagination;

      if (Array.isArray(sortBy)) {
        [sortBy] = sortBy;
      }
      if (Array.isArray(sortDesc)) {
        [sortDesc] = sortDesc;
      }

      await this.getAll({
        search: this.domainsTable.search,
        page,
        rowsPerPage: itemsPerPage,
        sortBy: sortBy || "id",
        descending: sortDesc
      });

      this.domainsTable.items = this.domains;
      this.domainsTable.total = Number.parseInt(this.domainsTotal, 10);
    },

    getWindowWidth() {
      if (process.client) {
        this.width =
          window.innerWidth > 800
            ? window.innerWidth * 0.94
            : window.innerWidth;
      }
    },
    openStatusDialog(id, orgId) {
      this.selectedDomain = { id, orgId };
      this.dialogStatus = true;
    },
    closeStatusDialog() {
      this.selectedDomain = {};
      this.dialogStatus = false;
    },
    async updateStatus(status) {
      const success = await this.updateDomain({
        id: this.selectedDomain.id,
        orgId: this.selectedDomain.orgId,
        body: { status }
      });
      if (success) {
        this.closeStatusDialog();
        await this.getAllDomains();
      }
    }
  }
};
</script>

<style></style>
